// used on web. you may need to use a polyfill for
// browsers that do not implement `crypto` interface (for example, IE < 11)
// or, you can use uuid@3.4.0 , which falls back to Math.random()
import { v4 as uuidv4 } from "uuid";

export async function getInstallationId() {
	return uuidv4();
}
